// extracted by mini-css-extract-plugin
export default {"resizer":"resizer___fBeUe","disable":"disable____hR5v","resizer_horizontal":"resizer_horizontal___zkBzL","resizer_vertical":"resizer_vertical___AfZWM"};